export const typography = {
  fontFamily: ['Plus Jakarta Sans', 'Inter', 'Roboto', 'Arial', 'sans-serif'].join(','),

  h1: {
    fontWeight: 900,
    letterSpacing: 0,
  },

  h2: {
    fontWeight: 800,
    letterSpacing: 0,
  },

  h3: {
    fontWeight: 800,
    letterSpacing: 0,
  },

  button: {
    fontWeight: 800,
    textTransform: 'none' as const,
  },
};
